import {
  AngularFirestore,
  AngularFirestoreCollection,
  DocumentData,
  QueryDocumentSnapshot
} from "@angular/fire/firestore";
import { Order } from "./order.model";
import { BehaviorSubject, Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { ProductType } from "../product/enums";
import { map } from "rxjs/operators";
import { CitySummary } from "./models/city-summary.model";
import { VenueSummary } from "./models/venue-summary.model";
import { OrderQuery } from "./order.factory";
import { Venue } from "../venue/venue.model";
import { OrderFactoryAnalytics } from "./order.factory.analytics";
import {
  TimeframeFilter,
  TodayFilter,
  YesterdayFilter,
  WeekToDateFilter,
  Last7DaysFilter,
  LastWeekFilter,
  MonthToDateFilter,
  LastMonthFilter,
  YearToDateFilter,
  Last12MonthsFilter,
  LastCalendarYear,
  CustomTimeframeFilter,
  Last30DaysFilter
} from "../timeframe/timeframes";
import { OrderExporter } from "./order.export";

export class VenueOrderFactory {
  private collection: AngularFirestoreCollection;

  public orders: Order[];

  public orders$: Observable<Order[]>;
  public analytics$: Observable<Order[]>;

  private query: OrderQuery;

  public timeframes: TimeframeFilter[] = [
    new TodayFilter(),
    new YesterdayFilter(),
    new WeekToDateFilter(),
    new Last7DaysFilter(),
    new LastWeekFilter(),
    new MonthToDateFilter(),
    new Last30DaysFilter(),
    new LastMonthFilter(),
    new YearToDateFilter(),
    new Last12MonthsFilter(),
    new LastCalendarYear(),
    new CustomTimeframeFilter(null, null)
  ];

  public itemsPerPageOptions: number[] = [10, 25, 50];

  public analytics: OrderFactoryAnalytics;

  constructor(private venue: Venue, private db: AngularFirestore) {
    this._start();
  }

  private _start() {
    this.analytics = new OrderFactoryAnalytics();
    this.query = new OrderQuery();
    this.query.setVenue(
      new VenueSummary(null, this.venue.name, this.venue.reference, this.venue.id)
    );
    this._update();
  }

  private _update() {
    this.collection = this.db.collection(environment.orders, ref =>
      this.query.query(ref)
    );
    this._refresh();
  }
  private _refresh() {
    this.orders$ = this.collection.snapshotChanges().pipe<Order[]>(
      map(orders => {
        let x: Order[] = [];
        this.analytics.initialize();
        this.analytics.setTimeframe(this.query.timeframe);

        for (let i = 0; i < orders.length; i++) {
          
          const order: Order = this._toObject(orders[i].payload.doc);

          if (this.venue.hideTicketOrders && order.product.type === 6) {
            continue;
          }

          if (order.vipPass != true){
            this.analytics.addOrder(order);
            if (
              (order.summary.redeemedAt == null && this.query.showOutstanding) ||
              (order.summary.redeemedAt != null && this.query.showRedeemed)
            ) {
              x.push(order);
            }
          }
          

          
        }

        this.analytics.next();
        this.query.setTotalOrders(x.length);

        return x;
      })
    );
  }

  private _toObject(doc: QueryDocumentSnapshot<DocumentData>): Order {
    return new Order(doc.data(), doc.ref);
  }

  public get totalOrders(): number {
    return this.query.totalOrders;
  }

  public export(orders: Order[], isAdmin: boolean): void {
    new OrderExporter(orders, this.currentTimeframe).export(isAdmin);
  }
  public exportCustomQuestions(orders: Order[], isAdmin: boolean): void {
    new OrderExporter(
      Array.from(orders.filter(order => order.user.responses.length != 0)),
      this.currentTimeframe
    ).export(isAdmin);
  }
  public setProductTypeFilter(productType: ProductType) {
    this.query.setProduct(productType);
    this._update();
  }

  public setTimeframeFilter(timeframe: TimeframeFilter) {
    this.query.setTimeframe(timeframe);
    this._update();
  }

  public setShowRedeemed(bool: boolean) {
    this.query.setRedeemed(bool);
    this._update();
  }

  public setShowOutstanding(bool: boolean) {
    this.query.setOutstanding(bool);
    this._update();
  }
  public onOrderFilterSearchChanged(text: string) {
    this.query.searchText = text;
  }
  public get currentCity(): CitySummary {
    return this.query.city;
  }

  public get currentVenue(): VenueSummary {
    return this.query.venue;
  }

  public get currentProductType(): ProductType {
    return this.query.product;
  }

  public get currentTimeframe(): TimeframeFilter {
    return this.query.timeframe;
  }
  public get currentSearchText(): string {
    return this.query.searchText;
  }
  public get showRedeemed(): boolean {
    return this.query.showRedeemed;
  }

  public get showOutstanding(): boolean {
    return this.query.showOutstanding;
  }
}
